function getBrPageContent(page, reference) {
  if (!page) {
    return void 0;
  }
  if (!reference) {
    return void 0;
  }
  return page.getContent(reference)?.getData();
}
export {
  getBrPageContent
};
//# sourceMappingURL=get-br-page-content.js.map
